<template>
	<a-dropdown
		v-if="options.length > 0"
		v-model="opened"
		:trigger="['click']"
		overlay-class-name="GTableFilterSelect"
	>
		<a>
			<fa-icon
				:class="$style.icon"
				icon="filter"
				class="ml-2 text-muted"
			/>
		</a>

		<a-menu
			slot="overlay"
			@click="menuClick"
		>
			<a-menu-item>
				<a-checkbox
					:indeterminate="checkedSome"
					:checked="checkedAll"
					@change="checkAll($event.target.checked)"
				>
					Todos
				</a-checkbox>
			</a-menu-item>

			<a-menu-divider />

			<a-menu-item
				v-for="(opt, key) in options"
				:key="key"
			>
				<a-checkbox
					:checked="checked[opt.id]"
					@change="check(key, $event.target.checked)"
				>
					{{ opt.name }}
				</a-checkbox>
			</a-menu-item>

			<a-menu-divider class="mb-0" />

			<a-menu-item :class="$style.actions">
				<a-button-group>
					<a-tooltip placement="bottom">
						<template slot="title">
							<span>Filtrar</span>
						</template>
						<a-button
							type="primary"
							@click="filter()"
						>
							<fa-icon icon="save" />
						</a-button>
					</a-tooltip>
					<a-tooltip placement="bottom">
						<template slot="title">
							<span>Borrar filtro</span>
						</template>
						<a-button
							type="danger"
							@click="unfilter()"
						>
							<fa-icon icon="eraser" />
						</a-button>
					</a-tooltip>
				</a-button-group>
			</a-menu-item>
		</a-menu>
	</a-dropdown>
</template>

<script>

export default {
	name: 'GTableFilterSelect',
	props: {
		index: {
			type: String,
			required: true
		},
		view: {
			type: String,
			required: true
		},
		filters: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			select: [],
			options: [],
			opened: false
		};
	},
	computed: {
		query() {
			return this.$query(this.view);
		},
		active() {
			const find = this.$query(this.view).filter.search({ type: 'select', field: this.index });
			if (find) return find;
			return false;
		},
		checked() {
			return this.options.map((i) => {
				const find = this.select.findIndex((si) => si.id === i.id);
				if (find > -1) return true;
				return false;
			});
		},
		checkedAll() {
			return (this.select.length === this.options.length && this.select.length > 0);
		},
		checkedSome() {
			return this.select.length > 0 && this.select.length < this.options.length;
		}
	},
	watch: {
		// active(val) {
		// 	if (!val) this.value = '';
		// }
	},
	created() {
		const app = this.$gestios.$cache.view(this.view).app;
		const fields = this.$gestios.$cache.app(app).data().Fields;

		if (this.filters.length > 0) {
			this.options = this.filters.map((f) => ({ id: f.value, name: f.text }));
		} else if (fields && fields[this.index]) {
			const field = fields[this.index];

			if (field.Vars) {
				const vars = JSON.parse(field.Vars);

				for (let i = 0; i < vars.length; i += 1) {
					const opt = vars[i];
					this.options.push(opt);
				}
			}
		}

		const filters = this.$query(this.view).filter.search({
			view: this.view,
			field: this.index,
			type: 'select'
		});

		if (filters) {
			const find = this.options.filter((opt) => {
				const find2 = filters[0].value.findIndex((val) => val === opt.id);
				if (find2 > -1) return true;
				return false;
			});

			find.forEach((opt) => {
				this.select.push(opt);
			});
		}
	},
	methods: {
		order(value = null) {
			if (value) {
				this.query.order.add({ field: this.index, value });
			} else {
				this.query.order.delete(this.index);
			}
		},
		check(index, val) {
			const item = this.options[index];
			const find = this.select.findIndex((si) => item.id === si.id);

			if (val && find === -1) {
				this.select.push(item);
			} else if (!val && find > -1) {
				this.select.splice(find, 1);
			}
		},
		checkAll(val) {
			if (val) {
				this.options.forEach((opt) => {
					this.select.push(opt);
				});
			} else {
				this.select = [];
			}
		},
		menuClick(e) {
			if (e.key === '3') {
				this.visible = false;
			}
		},
		filter() {
			const ids = this.select.map((opt) => opt.id);

			this.unfilter(false);

			if (ids.length > 0) {
				this.$query(this.view).filter.add({
					view: this.view,
					field: this.index,
					type: 'select',
					value: ids
				});
			}
		},
		unfilter(uncheck = true) {
			this.$query(this.view).filter.delete({
				view: this.view,
				field: this.index,
				type: 'select'
			});

			if (uncheck) this.select = [];
		}
	}
};
</script>

<style lang="scss" module>
	.icon{
		font-size: 12px;
	}

	.actions{
		padding: 0 !important;
	}
</style>

<style lang="scss">

	.GTableFilterSelect{
		.ant-dropdown-menu{
			padding: 0;
		}

		.ant-btn-group{
			width: 100%;
			display: flex;

			.ant-btn{
				flex: 1;
				border-top-left-radius: 0 !important;
				border-top-right-radius: 0 !important;
				border: 0;
			}
		}
	}

</style>
